var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"gap":"2px"}},[_vm._l((_vm.getPerStarRating),function(fillPercent,i){return _c('Star',{key:'star' + i,attrs:{"fillPercent":fillPercent}})}),(!_vm.removeAverage)?_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.rating.toPrecision(2).substring(0, 3)))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }